import ContributionsList from './ContributionsList';

export default ContributionsList;
